/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFilesDelete } from "../../funcs/llmFilesDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteFileRequest$inboundSchema,
};

export const tool$llmFilesDelete: ToolDefinition<typeof args> = {
  name: "llm-files-delete",
  description: `Delete file

Delete a file from storage. This will also remove it from any vector stores.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFilesDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
